import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
    postSearch(parameters={}) {
    return core.call({
      url: '/api/v1/external/post',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  custSearch(parameters={}) {
    return core.call({
      url: '/api/v1/mycstmr/getMyCstmrListForPop',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }
}
